import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Tableur / Excel — feuille avec grille duotone */
export const SpreadsheetIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Cellule en surbrillance menthe */}
      <rect x="13.5" y="13.5" width="4.5" height="3" rx="0.5" fill="var(--equiply-icon-bg)" />
      {/* Feuille */}
      <path
        d="M5 3.5h9l5 5v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 4 20.5V5a1.5 1.5 0 0 1 1.5-1.5z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Coin replié */}
      <path
        d="M14 3.5V7a1.5 1.5 0 0 0 1.5 1.5H19"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Grille */}
      <path d="M6 12h13M6 16.5h13M11 11v9M15.5 11v9" stroke="var(--equiply-icon-fg)" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  ),
);
SpreadsheetIcon.displayName = "SpreadsheetIcon";
